module.exports = __webpack_public_path__ + "static/Graphik-Medium-Cy-Web-ac22c56d8751a9dbf777ea261322043e.woff2";